import {BaseCollaboratorModal} from 'sma.applicant/components/collaborators/base_collaborator_modal';

class CollaboratorModal extends BaseCollaboratorModal {
	constructor(config) {
		super(
			{
				applicationId: config.applicationId,
				isOwner: config.isOwner,
				isViewer: config.isViewer,
				includeOwner: true,
			}
		);
	}

	postCollaboratorRemove(e) {
		new sma.applicants.detail.CollaboratorAvatars(this.applicationId);
	}
}

module.exports = {
	CollaboratorModal: CollaboratorModal,
}